import { Account } from '@app/core/resources/account';
import { BalanceAccountIds } from '../enums/balance-account-ids.enum';
import { generateBalanceSystem } from '../application/strategies/helpers/strategies.helpers';

export const generateBalanceAccount: () => Account = (): Account => {
    const account: Account = new Account();
    account.id = BalanceAccountIds.BALANCE_ACCOUNT_ID;
    account.attributes.alias = 'Saldoar';
    account.attributes.address = 'Mi balance';

    account.relationships.system.data = generateBalanceSystem();

    return account;
};
